export default __webpack_public_path__ + "static/media/noAddressFound.6335919a.svg";